export const NAVBAR_THEMES = {
  light: {
    bg:              "bg-white border-b",
    bgOpen:          "bg-white",
    text:            "text-[#212121]",
    iconBorder:      "[&>div]:border-[#212121]",
    loginBorder:     "border-[#212121]",
    authBtn:         "bg-white border-[#e0e0e0]",
    linkColor:       "text-[#212121]",
    pillBorder:      "border-[#e0e0e0]",
    divider:         "bg-[#e0e0e0]",
    loginIconBg:     "bg-[#212121]",
    megaMenuBg:       "bg-white",
    megaMenuBorder:   "border-[#e0e0e0]",
    megaMenuLink:     "text-[#616161] hover:text-primary",
    dropdownBg:       "bg-white",
    dropdownText:     "text-[#212121]",
    dropdownSubText:  "text-[#616161]",
    dropdownHover:    "hover:bg-gray-100",
    dropdownDivider:  "border-[#e0e0e0]",
    dropdownHeading:  "text-primary",
  },
  transparent: {
    bg:               "bg-transparent border-b border-b-white/40",
    bgOpen:           "bg-white",
    text:             "text-white",
    iconBorder:       "[&>div]:border-white text-white",
    loginBorder:      "border-white text-white",
    authBtn:          "bg-transparent border-white",
    linkColor:        "text-white",
    pillBorder:       "border-white/40",
    divider:          "bg-white/40",
    loginIconBg:      "bg-[#212121]",
    megaMenuBg:       "bg-white",
    megaMenuBorder:   "border-[#e0e0e0]",
    megaMenuLink:     "text-[#616161] hover:text-primary",
    dropdownBg:       "bg-white",
    dropdownText:     "text-[#212121]",
    dropdownSubText:  "text-[#616161]",
    dropdownHover:    "hover:bg-gray-100",
    dropdownDivider:  "border-[#e0e0e0]",
    dropdownHeading:  "text-primary",
  },
  dark: {
    bg:               "bg-[#092417] shadow-[inset_0_-1px_0_rgba(255,255,255,0.1)]",
    bgOpen:           "bg-[#092417]",
    text:             "text-[#C8D5CC]",
    iconBorder:       "[&>div]:border-[#C8D5CC] text-[#C8D5CC]",
    loginBorder:      "border-[#C8D5CC] text-[#C8D5CC]",
    authBtn:          "bg-transparent border-[#C8D5CC]",
    linkColor:        "text-[#C8D5CC]",
    pillBorder:       "border-[#C8D5CC]/40",
    divider:          "bg-[#C8D5CC]/40",
    loginIconBg:      "bg-[#C8D5CC]/20",
    megaMenuBg:       "bg-[#092417]",
    megaMenuBorder:   "border-[#C8D5CC]/20",
    megaMenuLink:     "text-white hover:text-primary",
    dropdownBg:       "bg-[#0d2e1c]",
    dropdownText:     "text-[#C8D5CC]",
    dropdownSubText:  "text-[#C8D5CC]/70",
    dropdownHover:    "hover:bg-white/10",
    dropdownDivider:  "border-[#C8D5CC]/20",
    dropdownHeading:  "text-primary",
  },
} as const;

export type NavbarTheme = keyof typeof NAVBAR_THEMES;
